import React from 'react';
import _orderBy from 'lodash/orderBy';
import AnalysisLibraryItem from './AnalysisLibraryItem';

const OneColumnLayout = ({
  items,
  projectId,
  analysisId,
  isLoading,
  isInMultipleColumnLayout = false,
}) => {
  const orderedItems = _orderBy(items, [(item) => item.order]);

  return orderedItems.map((item) => {
    return (
      <AnalysisLibraryItem
        item={item}
        key={`${item.id || item.libraryItemId}-${item.name}`}
        projectId={projectId}
        analysisId={analysisId}
        isLoading={isLoading}
        isInMultipleColumnLayout={isInMultipleColumnLayout}
      />
    );
  });
};

export default OneColumnLayout;
